import {Component,EventEmitter,HostListener,Input,Output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {A11yModule} from '@angular/cdk/a11y';
import {MatButtonModule} from '@angular/material/button';

/** Shared confirmation for attendance and survey results; never changes lifecycle itself. */
@Component({selector:'app-result-action-dialog',standalone:true,
  imports:[FormsModule,A11yModule,MatButtonModule],
  template:`
    <div class="backdrop" (click)="cancel()">
      <section role="dialog" aria-modal="true" aria-labelledby="result-action-title"
        cdkTrapFocus [cdkTrapFocusAutoCapture]="true" (click)="$event.stopPropagation()" [attr.aria-busy]="busy">
        <h2 id="result-action-title">{{title}}</h2>
        <ng-content></ng-content>
        @if (requiresReason) {
          <label for="result-action-reason">修正理由（必須）</label>
          <textarea id="result-action-reason" rows="3" maxlength="500" [disabled]="busy"
            [ngModel]="reason" (ngModelChange)="reasonChange.emit($event)"></textarea>
        }
        @if (error) {<p class="error" role="alert">{{error}}</p>}
        <div class="dialog-actions">
          <button mat-stroked-button type="button" [disabled]="busy" (click)="cancel()">キャンセル</button>
          <button mat-raised-button type="button" class="primary"
            [disabled]="busy||disabled||(requiresReason&&!reason.trim())" (click)="confirm()">{{busy?'処理中…':confirmLabel}}</button>
        </div>
      </section>
    </div>`,
  styles:[`
    :host{font-size:14px;line-height:1.6;color:#333}
    .backdrop{position:fixed;z-index:1100;inset:0;display:grid;place-items:center;padding:24px;background:#0008}
    section{box-sizing:border-box;width:min(560px,100%);max-height:calc(100dvh - 48px);overflow:auto;overscroll-behavior:contain;padding:24px;background:#fff;border:1px solid #dcdcdc;border-radius:10px;box-shadow:0 16px 48px #0003}
    h2{font-size:20px;line-height:1.5;margin:0 0 16px}label{display:block;margin-top:16px;font-weight:500}
    textarea{box-sizing:border-box;width:100%;margin-top:6px;padding:10px;border:1px solid #dcdcdc;border-radius:10px;font:inherit;resize:vertical}
    .dialog-actions{display:flex;justify-content:center;gap:12px;flex-wrap:wrap;margin-top:24px}
    button{min-height:44px;font:inherit;font-weight:500;border-radius:4px;padding:8px 20px}
    button.primary{background:#072f6b;color:#fff}button:disabled{opacity:.45}
    .error{color:#8f1e27;background:#fff1f1;padding:12px}
    textarea:focus-visible,button:focus-visible{outline:2px solid #3979bd;outline-offset:2px}
    @media(max-width:600px){.backdrop{padding:12px}section{padding:20px;max-height:calc(100dvh - 24px)}textarea{font-size:16px}.dialog-actions button{flex:1 1 140px}}
  `]})
export class ResultActionDialogComponent {
  @Input() title='';
  @Input() confirmLabel='確定する';
  @Input() busy=false;
  @Input() disabled=false;
  @Input() requiresReason=false;
  @Input() reason='';
  @Input() error='';
  @Output() reasonChange=new EventEmitter<string>();
  @Output() confirmed=new EventEmitter<void>();
  @Output() cancelled=new EventEmitter<void>();
  @HostListener('document:keydown.escape',['$event']) escape(event:KeyboardEvent){event.preventDefault();this.cancel();}
  cancel(){if(!this.busy)this.cancelled.emit();}
  confirm(){if(!this.busy&&!this.disabled&&(!this.requiresReason||this.reason.trim()))this.confirmed.emit();}
}
